import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
// Side-effecting import: sets up i18next (resources, initial language from localStorage, <html lang>)
// before anything renders. The language itself is decided in i18n/index.ts, not here — main.tsx no
// longer forces "en"; see the AppShell language switcher for how a user changes it.
import "@/i18n";
import { USE_MOCK_API } from "@/lib/env";
import { App } from "./App";
import "./styles/global.css";

async function bootstrap() {
  // Start the in-browser mock API before first render so no real network/creds are needed in dev.
  if (USE_MOCK_API) {
    const { startMockWorker } = await import("./mock/browser");
    await startMockWorker();
  }

  const rootEl = document.getElementById("root");
  if (!rootEl) throw new Error("Root element #root not found");

  createRoot(rootEl).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}

void bootstrap();
